import { actions } from '@/store/module/club/action/actions.js';
import { getters } from '@/store/module/club/getter/getters.js';
import { mutations } from '@/store/module/club/mutation/mutations.js';

export const club = {
	namespaced: true,

	state: {
		clubs: []
	},

	actions,
	getters,
	mutations
};
